import {EntityField} from "../../../core/genericdocuments/EntityField";
import {EntityFieldDataType} from "../../../core/genericdocuments/EntityFieldDataType";
import {EntityFieldsDescriptor} from "../../../core/genericdocuments/EntityFieldsDescriptor";
import {baseDocumentFields} from "../BaseDocumentFields";
import {LookupEntities} from "../../../core/genericdocuments/ReferenceDetails";
import {ZahtevZaRaskidPoliseDocument} from "./ZahtevZaRaskidPoliseDocument";

// obavezno: datum zavodjenja, delovodni broj, datum dokumenta, broj dokumenta, partner, sektor
// opciono: opis, lista priloga
export const zahtevZaRaskidPoliseDocumentFields: IntercateKeysMap<ZahtevZaRaskidPoliseDocument, EntityField<ZahtevZaRaskidPoliseDocument>> = {
	...baseDocumentFields,
	clientId: {
		name: "clientId", dataType: EntityFieldDataType._reference, label: "Partner",
		referenceDetails: {
			lookupOptions: null,
			lookupEntity: LookupEntities.Customers
		},
		validator: { required: true },
		sortable: true,
		autocomplete: true
	},
	policyNumber: {
		name: "policyNumber", dataType: EntityFieldDataType._string, label: "Broj polise",
		validator: { required: true },
		sortable: true,
		filterable: true
	},
	parentId: {
		name: "parentId", dataType: EntityFieldDataType._derived, label: "Parent",
		value: (item: { clientId: any; }) => item.clientId,
		hide: formState => true
	}
}

const documentFieldsArray: Array<EntityField<ZahtevZaRaskidPoliseDocument>> = [
	zahtevZaRaskidPoliseDocumentFields.indexingNumber,
	zahtevZaRaskidPoliseDocumentFields.indexingDate,
	zahtevZaRaskidPoliseDocumentFields.documentNumber,
	zahtevZaRaskidPoliseDocumentFields.documentDate,
	zahtevZaRaskidPoliseDocumentFields.policyNumber,
	zahtevZaRaskidPoliseDocumentFields.assignedTo,
	zahtevZaRaskidPoliseDocumentFields.clientId,
	zahtevZaRaskidPoliseDocumentFields.sectorId,
	zahtevZaRaskidPoliseDocumentFields.tags,
	zahtevZaRaskidPoliseDocumentFields.parentId
]

export const zahtevZaRaskidPoliseDocumentFieldsDescriptor: EntityFieldsDescriptor<ZahtevZaRaskidPoliseDocument> = {
	listFields: documentFieldsArray,
	createFormFields: documentFieldsArray,
	updateFormFields: documentFieldsArray
}
